export class State {
  isOpen: boolean = true;
  isMobileMenuOpen: boolean = false;
}
